export const  ImageUploadRoutes = {
    imageUpload: "/app/uploadImage",
    
  };
    